import React from "react";
import Footer from "../Components/Footer";
import ProfileNav from "../Components/ProfileNav";
import ReservationsTimeline from "../Components/reservations/ReservationsTimeline";
import "../Styles/Medyaf.css";

function VipReservationsPage() {
  return (
    <div>
      <div className="userProfile">
        <ProfileNav active="3" />
        <div className="profileBody">
          <ReservationsTimeline />
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default VipReservationsPage;

